// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskLookaheadQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  searchIntervalEnd: Types.Scalars['Date']['input'];
  searchIntervalStart: Types.Scalars['Date']['input'];
}>;


export type TaskLookaheadQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, project?:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
     | null | undefined, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] } }>, cohorts: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > }> };

export type TaskLookaheadCohortDetailsFragment = { __typename?: 'Cohort', id: string, name: string, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type TaskLookaheadRightPaneQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  searchIntervalEnd: Types.Scalars['Date']['input'];
  searchIntervalStart: Types.Scalars['Date']['input'];
}>;


export type TaskLookaheadRightPaneQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, status: Types.TaskStatus, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] }, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, schedule: { __typename?: 'Schedule', id: string, stage: Types.Stage }, scheduleFlags: Array<{ __typename?: 'ScheduleFlag', id: string, reason?: { __typename?: 'ScheduleFlagReason', id: string, title: string } | null | undefined }> }>, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
   };

export type TaskLookaheadRightPaneScheduleTaskFragment = { __typename?: 'ScheduleTask', id: string, name: string, status: Types.TaskStatus, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] }, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, schedule: { __typename?: 'Schedule', id: string, stage: Types.Stage }, scheduleFlags: Array<{ __typename?: 'ScheduleFlag', id: string, reason?: { __typename?: 'ScheduleFlagReason', id: string, title: string } | null | undefined }> };

export const TaskLookaheadCohortDetailsFragmentDoc = gql`
    fragment TaskLookaheadCohortDetails on Cohort {
  id
  name
  projects {
    id
    name
  }
}
    `;
export const TaskLookaheadRightPaneScheduleTaskFragmentDoc = gql`
    fragment TaskLookaheadRightPaneScheduleTask on ScheduleTask {
  id
  name
  status
  interval {
    startDate
    endDate
  }
  statusDetail {
    code
    name
  }
  schedule {
    id
    stage
  }
  scheduleFlags {
    id
    reason {
      id
      title
    }
  }
}
    `;
export const TaskLookaheadDocument = gql`
    query TaskLookahead($developmentId: ID!, $searchIntervalEnd: Date!, $searchIntervalStart: Date!) {
  scheduleTasks(
    filter: {projectTasksForDevelopment: $developmentId, status: [NOT_STARTED, COMPLETE, DELAYED, IN_PROGRESS, ON_HOLD], startDateRange: {op: ON_OR_BEFORE, value: $searchIntervalEnd}, endDateRange: {op: ON_OR_AFTER, value: $searchIntervalStart}}
    first: 5000
  ) {
    id
    project {
      id
    }
    interval {
      startDate
      endDate
    }
  }
  cohorts(filter: {development: [$developmentId]}) {
    ...TaskLookaheadCohortDetails
  }
}
    ${TaskLookaheadCohortDetailsFragmentDoc}`;

/**
 * __useTaskLookaheadQuery__
 *
 * To run a query within a React component, call `useTaskLookaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskLookaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskLookaheadQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      searchIntervalEnd: // value for 'searchIntervalEnd'
 *      searchIntervalStart: // value for 'searchIntervalStart'
 *   },
 * });
 */
export function useTaskLookaheadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskLookaheadQuery, TaskLookaheadQueryVariables> & ({ variables: TaskLookaheadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskLookaheadQuery, TaskLookaheadQueryVariables>(TaskLookaheadDocument, options);
      }
export function useTaskLookaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskLookaheadQuery, TaskLookaheadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskLookaheadQuery, TaskLookaheadQueryVariables>(TaskLookaheadDocument, options);
        }
// @ts-ignore
export function useTaskLookaheadSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskLookaheadQuery, TaskLookaheadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskLookaheadQuery, TaskLookaheadQueryVariables>;
export function useTaskLookaheadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskLookaheadQuery, TaskLookaheadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskLookaheadQuery | undefined, TaskLookaheadQueryVariables>;
export function useTaskLookaheadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskLookaheadQuery, TaskLookaheadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskLookaheadQuery, TaskLookaheadQueryVariables>(TaskLookaheadDocument, options);
        }
export type TaskLookaheadQueryHookResult = ReturnType<typeof useTaskLookaheadQuery>;
export type TaskLookaheadLazyQueryHookResult = ReturnType<typeof useTaskLookaheadLazyQuery>;
export type TaskLookaheadSuspenseQueryHookResult = ReturnType<typeof useTaskLookaheadSuspenseQuery>;
export type TaskLookaheadQueryResult = ApolloReactCommon.QueryResult<TaskLookaheadQuery, TaskLookaheadQueryVariables>;
export const TaskLookaheadRightPaneDocument = gql`
    query TaskLookaheadRightPane($projectId: ID!, $searchIntervalEnd: Date!, $searchIntervalStart: Date!) {
  scheduleTasks(
    filter: {project: [$projectId], status: [NOT_STARTED, COMPLETE, DELAYED, IN_PROGRESS, ON_HOLD], startDateRange: {op: ON_OR_BEFORE, value: $searchIntervalEnd}, endDateRange: {op: ON_OR_AFTER, value: $searchIntervalStart}}
  ) {
    ...TaskLookaheadRightPaneScheduleTask
  }
  project(id: $projectId) {
    id
    name
  }
}
    ${TaskLookaheadRightPaneScheduleTaskFragmentDoc}`;

/**
 * __useTaskLookaheadRightPaneQuery__
 *
 * To run a query within a React component, call `useTaskLookaheadRightPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskLookaheadRightPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskLookaheadRightPaneQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      searchIntervalEnd: // value for 'searchIntervalEnd'
 *      searchIntervalStart: // value for 'searchIntervalStart'
 *   },
 * });
 */
export function useTaskLookaheadRightPaneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables> & ({ variables: TaskLookaheadRightPaneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>(TaskLookaheadRightPaneDocument, options);
      }
export function useTaskLookaheadRightPaneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>(TaskLookaheadRightPaneDocument, options);
        }
// @ts-ignore
export function useTaskLookaheadRightPaneSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>;
export function useTaskLookaheadRightPaneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskLookaheadRightPaneQuery | undefined, TaskLookaheadRightPaneQueryVariables>;
export function useTaskLookaheadRightPaneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>(TaskLookaheadRightPaneDocument, options);
        }
export type TaskLookaheadRightPaneQueryHookResult = ReturnType<typeof useTaskLookaheadRightPaneQuery>;
export type TaskLookaheadRightPaneLazyQueryHookResult = ReturnType<typeof useTaskLookaheadRightPaneLazyQuery>;
export type TaskLookaheadRightPaneSuspenseQueryHookResult = ReturnType<typeof useTaskLookaheadRightPaneSuspenseQuery>;
export type TaskLookaheadRightPaneQueryResult = ApolloReactCommon.QueryResult<TaskLookaheadRightPaneQuery, TaskLookaheadRightPaneQueryVariables>;